import React from 'react';
import styles from './Copyright.css';

const Copyright = () => (
  <p className={styles.copyright}>
    &copy; {new Date().getFullYear()} Covetrus. All rights reserved.
  </p>
);

export default Copyright;



// WEBPACK FOOTER //
// ./src/components/Copyright.jsx